import classNames from "classnames/bind";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  color?: "#fd6a65" | "black";
  size?: 40 | 32 | 24;
  withBackground?: boolean;
}

export const SimulationIcon: React.FC<React.PropsWithChildren<Props>> = ({
  color = "#fd6a65",
  size = 24,
  withBackground = false,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="scale(0.6) translate(6, 6)">
          <path
            d="M12.3947 2.17634C12.6468 1.53959 13.1139 0.988338 13.7317 0.598555C14.3494 0.208771 15.0873 -0.000353612 15.8438 4.48841e-07H23.1562C23.9127 -0.000353612 24.6506 0.208771 25.2683 0.598555C25.886 0.988338 26.3532 1.53959 26.6053 2.17634H30.4688C31.4384 2.17634 32.3684 2.52028 33.0541 3.13249C33.7398 3.74471 34.125 4.57505 34.125 5.44085V17.4107H31.6875V5.44085C31.6875 5.15225 31.5591 4.87547 31.3305 4.6714C31.102 4.46733 30.792 4.35268 30.4688 4.35268H26.6053C26.3532 4.98943 25.886 5.54068 25.2683 5.93046C24.6506 6.32025 23.9127 6.52937 23.1562 6.52902H15.8438C15.0873 6.52937 14.3494 6.32025 13.7317 5.93046C13.1139 5.54068 12.6468 4.98943 12.3947 4.35268H8.53125C8.20802 4.35268 7.89802 4.46733 7.66946 4.6714C7.4409 4.87547 7.3125 5.15225 7.3125 5.44085V17.4107H4.875V5.44085C4.875 4.57505 5.26021 3.74471 5.94589 3.13249C6.63157 2.52028 7.56155 2.17634 8.53125 2.17634H12.3947ZM15.8438 2.17634C15.5205 2.17634 15.2105 2.29099 14.982 2.49506C14.7534 2.69913 14.625 2.97591 14.625 3.26451C14.625 3.55311 14.7534 3.82989 14.982 4.03396C15.2105 4.23803 15.5205 4.35268 15.8438 4.35268H23.1562C23.4795 4.35268 23.7895 4.23803 24.018 4.03396C24.2466 3.82989 24.375 3.55311 24.375 3.26451C24.375 2.97591 24.2466 2.69913 24.018 2.49506C23.7895 2.29099 23.4795 2.17634 23.1562 2.17634H15.8438ZM31.6875 23.9397H34.125V31.5569C34.125 32.4227 33.7398 33.2531 33.0541 33.8653C32.3684 34.4775 31.4384 34.8214 30.4688 34.8214H8.53125C7.56155 34.8214 6.63157 34.4775 5.94589 33.8653C5.26021 33.2531 4.875 32.4227 4.875 31.5569V23.9397H7.3125V31.5569C7.3125 31.8455 7.4409 32.1223 7.66946 32.3264C7.89802 32.5304 8.20802 32.6451 8.53125 32.6451H30.4688C30.792 32.6451 31.102 32.5304 31.3305 32.3264C31.5591 32.1223 31.6875 31.8455 31.6875 31.5569V23.9397ZM17.0089 10.5618C16.936 10.3498 16.7923 10.1629 16.5971 10.0258C16.402 9.88879 16.1645 9.80826 15.9167 9.79501C15.6688 9.78175 15.4224 9.83641 15.2103 9.95166C14.9981 10.0669 14.8305 10.2373 14.7298 10.4399L10.1766 19.5871H1.21875C0.895517 19.5871 0.585524 19.7017 0.356964 19.9058C0.128404 20.1098 0 20.3866 0 20.6752C0 20.9638 0.128404 21.2406 0.356964 21.4447C0.585524 21.6487 0.895517 21.7634 1.21875 21.7634H10.9688C11.2046 21.7634 11.4353 21.7024 11.633 21.5876C11.8308 21.4729 11.9869 21.3094 12.0827 21.117L15.6366 13.9786L19.5536 25.3478C19.6251 25.5556 19.7647 25.7394 19.9543 25.8757C20.1439 26.012 20.3749 26.0945 20.6175 26.1125C20.8601 26.1306 21.1031 26.0833 21.3154 25.9769C21.5276 25.8705 21.6993 25.7097 21.8083 25.5154L25.5938 18.7557L26.9417 21.1627C27.043 21.3432 27.1986 21.495 27.391 21.6011C27.5834 21.7072 27.8051 21.7634 28.0313 21.7634H37.7812C38.1045 21.7634 38.4145 21.6487 38.643 21.4447C38.8716 21.2406 39 20.9638 39 20.6752C39 20.3866 38.8716 20.1098 38.643 19.9058C38.4145 19.7017 38.1045 19.5871 37.7812 19.5871H28.7844L26.6833 15.835C26.582 15.6545 26.4264 15.5028 26.234 15.3967C26.0416 15.2906 25.8199 15.2344 25.5938 15.2344C25.3676 15.2344 25.1459 15.2906 24.9535 15.3967C24.7611 15.5028 24.6055 15.6545 24.5042 15.835L20.9869 22.1116L17.0089 10.5618Z"
            fill={color}
          />
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
